import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import TextInput from "src/components/Form/TextInput";
import TextAreaInput from "src/components/Form/TextAreaInput";
import Button from "src/components/Form/Button";
import useFormFields from "src/hooks/useFormFields";
import useTextArea from "src/hooks/useTextArea";

import { useContext, useEffect, useState } from "react";
import CustomOptionBox from "src/components/Form/CustomOptionBox";
import CustomOptionSingleSelect from "src/components/Form/CustomOptionSingleSelect";
import CustomOptionSelect from "src/components/Form/CustomOptionSelect";
import CheckBox from "src/components/Form/CheckBox";
import Option from "src/components/Form/Option";
import EnhanceSelectBox from "src/components/Form/EnhanceSelectBox";
import usePersistantState from "src/hooks/usePersistantState";
import userContext from "src/context/userContext";
import jobContext from "src/context/jobContext";



export default function JobAnalysisPage0({ handleStep, handleStepDown }) {

    const { job } = useContext(jobContext)

    let arshad = {
        "مشارکت در فرایند تهیه و تدوین اهداف و برنامه‌ریزی های كلان سازمان در جهت ایجاد همسویی فعالیتهای زیر مجموعه با اهداف کلان کسب و کار سازمان": false,
        "نظارت راهبردی بر تدوین برنامه های عملیاتی مجموعه تحت سرپرستی براساس نوع کار و نیازهای مجموعه به منظور بهره برداری بهینه از منابع و امکانات موجود": false,
        "سازماندهی کارکنان و وظایف مجموعه تحت سرپرستی و ارجاع کارها براساس عنوان پست، نوع وظایف ، تخصص و حجم کار افراد": false,
        "فراهم نمودن شرایط لازم جهت یادگیری و انتقال ابزارهای نوین مدیریتی به افراد تحت سرپرستی": false,
        "ایجاد و توسعه ارتباط با سازمان ها و نهادهای برون سازمانی به منظور پیشبرد اهداف سازمان": false,
        "نظارت مستمر بر فرآیندها و روش های انجام کار واحد های زیر مجموعه به منظور حذف تشریفات ، رفع نواقص و گلوگاه ها": false,
        "بررسی و تایید اهداف، برنامه ها و استراتژی های مرتبط با مجموعه تحت نظارت همسو با اهداف و استراتژیهای کلان سازمان": false,
        "نظارت راهبردی بر فعالیت واحدهای زیربط جهت هدایت آنها در مسیر تحقق چشم انداز و سیاستهای سازمان": false,
        "نظارت بر تدوین گزارشات تحلیلی و ادواری فعالیت ها و اقدامات انجام شده و تبیین نارسائیهای وضع موجود و پیشنهاد رفع و بهبود آن": false,
        "حضور موثر در جلسات، مجامع، کمیسیون ها و کمیته های مختلف داخل و خارج از سازمان حسب مورد": false,
        "نظارت راهبردی بر عملکرد کارکنان تحت سرپرستی و ارایه رهنمودهای لازم به منظور ارتقای بهره وری منابع انسانی": false,
        "ارزیابی و مدیریت عملکرد پرسنل بلافصل ، بررسی و تصویب نقطه نظرات مدیران تحت سرپرستی در خصوص ارزیابی عملکرد کارکنان زیر مجموعه": false,
        "مشارکت در تدوین دستورالعملها و نظام های مرتبط و استقرار و اجرای انواع استانداردها و سیستم های مدیریتی": false,
        "ایجاد انگیزه و رغبت شغلی در کارکنان با بهره گیری مناسب از مکانیزم های تشویقی و تنبیهی": false,
        "نظارت برانجام پروژه های مشاوره ای یا تحقیقاتی مرتبط براساس قراردادهای مبادله شده به منظور کنترل کیفی، کمی و زمانی پروژه ها.": false,
        "نظارت بر حسن اجرای الزامات ایمنی کارکنان و الزامات زیست محیطی و بهداشت محیط کار": false,
        "انتقال مستمر دانش و تجارب کلیدی به کارکنان مستعد به منظور تیجاد یادگیری سازمانی": false,
        "تصویب و تایید نهایی مرخصی، ماموریت و اضافه کاری کارکنان تحت سرپرستی بر اساس دستورالعمل ها و رویه های سازمان": false
    }
    let miani = {
        "تهیه و ارائه اهداف، برنامه ها و استراتژی های مرتبط با مجموعه تحت نظارت بر اساس اهداف و استراتژیهای کلان سازمان": false,
        "ایجاد و توسعه زمینه های ارتباطی واحدهای ذیربط با سازمانها و نهادهای برون سازمانی": false,
        "نظارت بر فرایند تعریف و اجرای پروژه ها و طرح هایی كه به تدبیر مقام مافوق یا در چارچوب برنامه های کلان سازمان تعریف می شود.": false,
        "تجزیه و تحلیل و ارزیابی و ارائه بازخورد مستمر نتایج حاصل از عملكرد، برنامه ها و اهداف پیش بینی شده": false,
        "برنامه‌ریزی و اتخاذ تدابیر لازم در رابطه با سازو كارهای انگیزشی مجموعه تحت نظارت به منظور ارتقاء كمی و كیفی عملكرد": false,
        "ارائه گزارشهای تحلیلی ادواری و مقطعی از عملكرد مجموعه تحت سرپرستی به مقام مافوق": false,
        "سازمان در سمینارها، نشست ها و جلسات مرتبط به منظور توانمندسازی و ارتقای ظرفیت های سازمانی": false,
        "سازماندهی کارکنان و وظایف مجموعه تحت سرپرستی و ارجاع کارها براساس عنوان پست، نوع وظایف ، تخصص و حجم کار افراد": false,
        "نظارت بر عملکرد افراد تحت سرپرستی و ارایه راهنمایی های لازم به منظور حصول اطمینان از صحت انجام امور": false,
        "ارزیابی و مدیریت عملکرد پرسنل بلافصل ، بررسی و تایید نقطه نظرات روسا و مسئولین تحت سرپرستی در خصوص ارزیابی عملکرد کارکنان زیر مجموعه": false,
        "فراهم نمودن شرایط لازم جهت یادگیری و انتقال ابزارهای نوین مدیریتی به افراد تحت سرپرستی": false,
        "نظارت مستمر بر حسن اجرای الزامات ایمنی کارکنان و الزامات زیست محیطی و بهداشت محیط کار": false,
        "جانشین پروری و انتقال مستمر دانش و تجارب سازمانی به کارکنان مستعد در چارچوب نظام شایستگی سازمان": false,
        "بررسی و تایید مرخصی، ماموریت و اضافه کاری کارکنان تحت سرپرستی بر اساس دستورالعمل ها و رویه های سازمان": false,
    }
    let amaliati = {
        "کنترل مستمر اجرای قوانین، مقررات، دستورالعملها، بخشنامه‌ها و استانداردهای مرتبط شغلی": false,
        "هدایت و کنترل فعالیت های كارکنان تحت سرپرستی و پیگیری به منظور رفع مشكلات كاری آنها": false,
        "هماهنگی و نظارت كارشناسان تحت سرپرستی در گردآوری، دسته‌بندی، پردازش و تحلیل اطلاعات شغلی و ارائه گزارشات تحلیلی، مقایسه‌ای و آماری از عملكرد گروه مربوط": false,
        "مشاركت مستمر در جلسات، همایشها، سمینارها و دوره‌های‌های آموزشی مرتبط با زمینه‌كاری به منظور ارتقاء و بروزرسانی دانش و مهارتهای مورد نیاز": false,
        "برنامه‌ریزی به منظور بهره‌مندی و بكارگیری نرم‌افزارها و فن‌آوریهای اطلاعاتی بروز و كارآمد در انجام وظایف كاری": false,
        "برنامه‌ریزی به منظور ارزیابی مستمر فعالیتها و عملكرد كارشناسان تحت سرپرستی و شناسایی تنگناها و مشكلات موجود و پیگیری به منظور رفع آنها": false,
        "هماهنگی و مشاركت فعال در تدوین اهداف و برنامه‌های واحد سازمانی و پیگیری به منظور حصول آنها": false,
        "هماهنگی و مشاركت فعال در برنامه‌های ارزیابی و پاسخگویی واحد سازمانی مربوط و ارایه گزارشات مدیریتی و كارشناسی در این رابطه": false,
        "کنترل عملکرد افراد تحت سرپرستی و ارایه بازخوردهای لازم به منظور بهبود عملکرد و ایجاد نظم و انضباط کاری": false,
        "ارزیابی و مدیریت عملکرد پرسنل تحت سرپرستی به منظور شناسایی نقاط ضعف و قوت و انجام اقدام لازم در جهت رفع نقاط ضعف": false,
        "مستندسازی و آرشیو مدارک جهت نگهداری از اطلاعات و بهره برداری از آنها در مواقع لازم": false,
        "شناسایی و معرفی افراد مستعد جهت جانشین پروری و ارتقای شغلی و پستی در چارچوب نظام شایستگی سازمان": false,
        "کنترل مستمر فعالیتهای زیر مجموعه در زمینه اجرای الزامات ایمنی کارکنان و الزامات زیست محیطی و بهداشت محیط کار": false,
        "بررسی و تایید اولیه مرخصی، ماموریت و اضافه کاری کارکنان تحت سرپرستی بر اساس دستورالعمل ها و رویه های سازمان": false,
    }
    let masoulghesmatha = {
        "بکارگیری قوانین، مقررات، دستورالعملها و استانداردهای شغلی و اجرایی در فرایند کاری مربوطه": false,
        "همكاری و مشاركت فعال در گردآوری، دسته‌بندی و پردازش اطلاعات شغلی مربوط و ارائه گزارشات تحلیلی، مقایسه‌‌ای و آماری": false,
        "سازمان در همایشها، سمینارها و دوره‌های آموزشی مرتبط با زمینه‌ كاری به منظور ارتقاء و بروزرسانی دانش و مهارتهای مورد نیاز": false,
        "بهره‌مندی و بكارگیری موثر نرم‌افزارها و فن‌آوریهای نوین در انجام وظایف شغلی": false,
        "بررسی و ارزیابی مستمر چگونگی انجام فعالیتهای شغلی و ارائه بازخوردهای مناسب و به موقع از تنگناها و مشكلات موجود به مقام بالاتر": false,
        "رعایت اصول كیفی در انجام وظایف و مسئولیتهای محوله به منظور پاسخگویی به نیازمندیهای نظام كیفیت سازمان": false,
        "مشاركت فعال در تدوین اهداف و برنامه‌های حوزه کاری و فرایندهای مربوط و همكاری در دستیابی به آنها": false,
        "مشاركت فعال در ارزیابیها و پاسخگویی‌های واحد سازمانی مربوط و ارائه گزارشات كارشناسی در این رابطه": false,
        "اهتمام در ارائه راهكارها و سازوكارهای نوآورانه در جهت بهبود عملكرد شغلی و ارتقاء كمی و كیفی وظایف محوله": false,
        "مستندسازی، آرشیو و نگهداری از اطلاعات و مدارك": false,
        "ارائه گزارش عملكرد فرایند کاری مربوط بر اساس دستورالعمل‌ها و انتظارات مافوق": false,
        "رعایت نکات ایمنی ، الزامات زیست محیطی و بهداشت محیط کار": false,
    }
    let karshenasha = {
        "مطالعه و بررسی‌های مستمر به منظور بکارگیری موثر قوانین، مقررات، دستورالعملها و استانداردهای شغلی": false,
        "همكاری و مشاركت فعال در گردآوری، دسته‌بندی و پردازش اطلاعات شغلی مربوط و ارائه گزارشات تحلیلی، مقایسه‌‌ای و آماری": false,
        "سازمان در همایشها، سمینارها و دوره‌های آموزشی مرتبط با زمینه‌ كاری به منظور ارتقاء و بروزرسانی دانش و مهارتهای مورد نیاز": false,
        "بهره‌مندی و بكارگیری آخرین نرم‌افزارها و فن‌آوریهای اطلاعاتی در انجام وظایف شغلی": false,
        "بررسی و ارزیابی مستمر چگونگی انجام فعالیتهای شغلی و ارائه بازخوردهای مناسب و به موقع از تنگناها و مشكلات موجود به مقام بالاتر": false,
        "رعایت اصول كیفی در انجام وظایف و مسئولیتهای محوله به منظور پاسخگویی به نیازمندیهای نظام كیفیت سازمان": false,
        "تصمیم سازی و ارائه پیشنهادهای موثر در جهت تسهیل و ارتقای سطح کیفی فعالیت های کاری": false,
        "مشاركت فعال در ارزیابیها و پاسخگویی‌های واحد سازمانی مربوطه و ارائه گزارشات كارشناسی در این رابطه": false,
        "ارائه راهكارها و سازوكارهای نوآورانه در جهت بهبود عملكرد شغلی و ارتقاء كمی و كیفی وظایف محوله": false,
        "آرشیو و نگهداری از كلیه اطلاعات، فرآورده‌ها و مستندات": false,
        "ارائه گزارش عملكرد فردی بر اساس دستورالعمل‌های سازمان": false,
        "رعایت نکات ایمنی ، الزامات زیست محیطی و بهداشت محیط کار": false,
    }
    let karmandan = {
        "بکارگیری موثر قوانین، مقررات، دستورالعملها و استانداردهای شغلی و مشاركت در اجرای آنها": false,
        "همكاری و مشاركت فعال در گردآوری و دسته‌بندی اطلاعات مرتبط شغلی و ارایه گزارشات آماری مربوطه": false,
        "سازمان در دوره‌های آموزشی مرتبط با زمینه كاری به منظور ارتقا دانش و مهارتهای مورد نیاز شغلی": false,
        "بهره‌مندی و بكارگیری نرم‌افزارهای مرتبط شغلی": false,
        "پیگیری مكاتبات و سایر مسایل و مشكلات جاری واحد سازمانی مربوط، براساس دستور مقام مافوق": false,
        "همكاری و مشاركت در ارایه آمارها و سایر اطلاعات مربوط در ارزیابیها و پاسخگویی‌های واحد سازمانی": false,
        "رعایت اصول كیفی در انجام وظایف و مسئولیتهای محوله به منظور پاسخگویی به نیازمندیهای نظام كیفیت": false,
        "تهیه و ارائه گزارش عملكرد فردی به مافوق سازمانی": false,
        "رعایت نکات ایمنی ، الزامات زیست محیطی و بهداشت محیط کار": false,
    }
    let teknesianha = {
        "همكاری در جمع آوری اطلاعات و مشخصات مورد نیاز برای انجام كار": false,
        "تهیه لیست ملزومات و وسایل مورد نیاز و پیگیری درخواست و تهیه آنها با هماهنگی مافوق": false,
        "رعایت و اجرای قوانین و دستورالعمل های مرتبط با پست مورد تصدی و حسن انجام آنها": false,
        "حفظ، نگهداری و بهره برداری صحیح از ابزار و تجهیزات در اختیار": false,
        "تهیه و تنظیم آمار و گزارشات مورد نیاز و ارائه به مافوق": false,
        "گذراندن دوره های آموزشی مرتبط به پست سازمانی طبق نظام آموزشی سازمان": false,
        "رعایت نکات ایمنی ، الزامات زیست محیطی و بهداشت محیط کار": false,
    }
    let kargarha = {
        "حفظ، نگهداری و بهره برداری صحیح از ابزار و تجهیزات در اختیار": false,
        "تهیه لیست ملزومات و وسایل مورد نیاز و پیگیری درخواست و تهیه آنها با هماهنگی مافوق": false,
        "رعایت و اجرای قوانین و دستورالعمل های مرتبط با پست مورد تصدی و حسن انجام آنها": false,
        "گذراندن دوره های آموزشی مرتبط به پست سازمانی طبق نظام آموزشی سازمان": false,
        "رعایت نکات ایمنی ، الزامات زیست محیطی و بهداشت محیط کار": false,
    }


    const [industry, setIndustry] = usePersistantState("industry", {
        "خدمات اداری و پشتیبانی": false,
        "حمل و نقل و انبارداری": false,
        "فرهنگ و هنر": false,
        "آموزش و پژوهش": false,
        "کشاورزی": false,
        "مالی، مالیاتی و بیمه": false,
        "بانکداری": false,
        "بهداشت و سلامت": false,
        "هتلداری و گردشگری": false,
        "املاک و مستغلات": false,
        "فناوری اطلاعات و ارتباطات": false,
        "عمران و ساخت": false,
        "تجارت و فروش": false,
        "صنایع غذایی": false,
        "معدن و اکتشاف": false,
        "نفت، گاز و پتروشیمی": false,
    })


    const [vazayefOmoomi, setVazayefOmoomi] = usePersistantState("vazayefOmoomi", arshad);

    const [isVazayefOmoomi, setIsVazayefOmoomi] = useState(false);

    const { fields, handleChange } = useFormFields({
        jobTitle: job.title
    }, "baseInfo")
    const { textarea: jobDefinition, handleChange: handleTextArea } = useTextArea(null, "jobDefinition");


    const [rade, setRade] = usePersistantState("rade", {
        "مدیران ارشد": false,
        "مدیران میانی": false,
        "مدیران عملیاتی": false,
        "مسئول قسمت ها": false,
        "کارشناسان و کارشناسان مسئول": false,
        "کارمندان و متصدیان": false,
        "تکنسین و اپراتور ها": false,
        "مشاغل کارگری": false,
    });


    /* vazayef takhasosi shoghl */
    const [tasks, setTasks] = usePersistantState("tasks", []);
    const [change, setChange] = useState(true);
    const addTask = () => {
        if (taskInputs.length < 14) {
            const newTasks = tasks;
            newTasks.push((tasks.length) + 1);
            setTasks(newTasks);
            setChange(!change);
        }
    }
    const handleDelete = (index) => {
        let newTask = tasks;
        newTask.splice(index, 1);
        setTasks(newTask);
        setChange(!change);
    }
    const taskInputs = tasks.map((task, index) => {
        if (index + 1 == tasks.length) {
            return (<TextInput value={fields[`وظیفه تخصصی ${index + 2}`]} inputName={`وظیفه تخصصی ${index + 2}`} label=" " index={index} key={index} placeholder={`وظیفه ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} isLast={true} />)
        } else {
            return (<TextInput value={fields[`وظیفه تخصصی ${index + 2}`]} inputName={`وظیفه تخصصی ${index + 2}`} label=" " index={index} key={index} placeholder={`وظیفه ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} />)
        }
    })
    /* vazayef takhasosi shoghl */





    let vazayefOmoomiList = "";
    Object.keys(vazayefOmoomi).forEach(key => {
        if (vazayefOmoomi[key]) {
            vazayefOmoomiList = vazayefOmoomiList + key + " <br>"
        }
    });



    const handleVazayefOmoomiBox = () => {
        setIsVazayefOmoomi(!isVazayefOmoomi);
    }
    const handleVazayefOmoomi = (field) => {
        let count = -120;
        for (var key in vazayefOmoomi) {
            if (vazayefOmoomi.hasOwnProperty(key) && vazayefOmoomi[key]) {
                count = count + 1;
            }
        }
        if (count < 5 || vazayefOmoomi[field]) {
            setVazayefOmoomi({
                ...vazayefOmoomi,
                [field]: !(vazayefOmoomi[field]),
            })
        }
    }

    const vazayefOmoomiCheckLists = Object.keys(vazayefOmoomi).map((key, index) => (<CheckBox label={key} key={index} data={vazayefOmoomi} handleCheck={() => handleVazayefOmoomi(key)} />));

    const handleChangeRade = (rade) => {

        if (Object.values(rade)[0]) {
            setVazayefOmoomi(arshad)
        } else if (Object.values(rade)[1]) {
            setVazayefOmoomi(miani);
        } else if (Object.values(rade)[2]) {
            setVazayefOmoomi(amaliati);
        } else if (Object.values(rade)[3]) {
            setVazayefOmoomi(masoulghesmatha);
        } else if (Object.values(rade)[4]) {
            setVazayefOmoomi(karshenasha);
        } else if (Object.values(rade)[5]) {
            setVazayefOmoomi(karmandan);
        } else if (Object.values(rade)[6]) {
            setVazayefOmoomi(teknesianha);
        } else if (Object.values(rade)[7]) {
            setVazayefOmoomi(kargarha);
        }
    }


    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={0} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">
                <div className="bg-gray-100 mb-9 -m-10 rounded-lg p-4 font-semibold text-lg">1- تعریف و شرح وظایف شغل</div>
                <TextInput value={job.organization ? job.organization.name : fields.orgName} label="نام سازمان :" inputName="orgName" handleChange={handleChange} />
                <TextInput value={job ? job.orgUnit : fields.vahedSazmani} label="واحد سازمانی :" placeholder="منظور از واحد سازمانی، اداره کل، اداره معاونت و ... است که شغل در آن قرار گرفته است" inputName="vahedSazmani" handleChange={handleChange} />
                {/* <div className="relative cursor-pointer">
                    <EnhanceSelectBox state={industry} setState={setIndustry} label="خوشه صنعت: " />
                </div> */}
                <TextInput value={job ? job.title : fields.jobTitle} label="عنوان شغل :" placeholder="مثال تحلیلگر سیستم" inputName="jobTitle" handleChange={handleChange} />
                <TextAreaInput value={jobDefinition} label="تعریف شغل :" handleChange={handleTextArea} placeholder="مثال : تحلیلگر سیستم به انجام امور مربوط به عملکرد سیستم ها و فعالیت ها و تعیین نیاز ها به منظور شناخت وضعیت موجود ، جمع آوری ، تبدیل و استخراج اطلاعات ، طبقه بندی و تجزیه و تحلیل اطلاعات ، تعیین و ارائه ضوابط جامع طراحی سیستم های رایانه ای و طراحی تفصیلی طرح های پیشنهادی و انجام امور مربوط به برنامه ریزی آموزشی می پردازد." />

                <div className="relative cursor-pointer">
                    <EnhanceSelectBox state={rade} setState={setRade} label="رده شغلی: " additionalAction={handleChangeRade} />
                </div>


                <div className="relative cursor-pointer">
                    <CustomOptionSelect value={vazayefOmoomiList} label="شرح وظایف عمومی :" handleClick={(e) => { handleVazayefOmoomiBox(); e.stopPropagation() }} />
                    <CustomOptionBox isActive={isVazayefOmoomi} clickHandle={handleVazayefOmoomiBox}>
                        <div className="flex flex-row justify-between ">
                            <div>
                                {vazayefOmoomiCheckLists}
                            </div>
                        </div>
                        <Button title="ثبت تغییرات" direction="left" handleClick={() => { handleVazayefOmoomiBox() }} />
                    </CustomOptionBox>
                </div>
                <TextInput value={fields[`وظیفه تخصصی ${1}`]} label="شرح وظایف تخصصی :" placeholder="وظیفه 1 - صرفا وظایف تخصصی یا اختصاصی هر شغل در این قسمت باید وارد شود." inputName="وظیفه تخصصی 1" handleChange={handleChange} />
                <div className="">
                    {taskInputs}
                </div>
                <div className="flex items-center mb-5">
                    <div className="w-28 inline-block text-right mr-4 text-gray-500"></div>
                    <button onClick={addTask}
                        className="flex w-[250px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300">
                        <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">+</span>
                        اضافه کردن وظیفه تخصصی
                    </button>
                </div>
                <div className="flex flex-row justify-center items-center">
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} color="#5B5CFF" />
                </div>
            </div>
        </PanelLayout>
    )
}